// @flow

import React, {Component, Children, cloneElement} from 'react';
import {withCssModule} from '@pb/kit-util-with-css-module';

import noop from 'lodash.noop';
import styles from './table.component.module.styl';


const classNames = withCssModule(styles);

/**
 * Row component Props
 */
type RowProps = {|
    /**
     * Unique identifier the element
     */
    id?: string,
    /**
     * @private
     * If cell in table head
     */
    th?: boolean,
    /**
     * Set true to show custom zebra
     */
    showCustomZebra?: boolean,
    /**
     * Set true to show zebra
     */
    showZebra?: boolean,
    /**
     * Cell top border
     */
    cellBorder?: boolean,
    /**
     * All Cells in Row highlighted
     */
    highlighted?: boolean,
    children: React$Node,
    /**
     * Mix for Row
     */
    mix: string,
    catchRef?: ?HTMLTableRowElement => void,
    onClick: () => void,
    onMouseEnter: () => void,
    onMouseLeave: () => void,
|};

export class Row extends Component<RowProps> {

    static defaultProps = {
        th: false,
        cellBorder: true,
        highlighted: false,
        showZebra: true,
        mix: '',
        onClick: noop,
        onMouseEnter: noop,
        onMouseLeave: noop
    };

    render() {
        const props = this.props;
        const isCaption = child => child && child.props.caption;

        const classes = classNames('table__row', {
            table__row_head: props.th,
            table__row_body: !props.th,
            table__row_body_zebra: props.showZebra && props.showCustomZebra === undefined,
            table__row_body_custom_zebra: props.showCustomZebra,
            table__row_border: !props.cellBorder,
            table__row_highlighted: props.highlighted,
            table__row_caption: Children.map(props.children, child => isCaption(child)).length > 0,
            [props.mix]: props.mix
        });

        const children = props.th ? Children.map(
            props.children, child => {
                if (!child) {
                    return null;
                }
                return cloneElement(child, {th: props.th});
            }
        ) : props.children;

        return (
            <tr
                id={props.id}
                className={classes}
                onClick={this.props.onClick}
                onMouseEnter={this.props.onMouseEnter}
                onMouseLeave={this.props.onMouseLeave}
                ref={tr => props.catchRef && props.catchRef(tr)}>
                {children}
            </tr>
        );
    }
}
